import type { Hook } from '../types';

export function beforeRenderTimeline(...args: Parameters<Hook['beforeRenderTimeline']>) {
  // 业务方传入api
}

export default beforeRenderTimeline;
